import tw, { styled } from "twin.macro"
import { Body } from "../../Styled/Text"

export const Wrapper = styled.div`
  ${tw`text-left text-8 lg:text-12`}
  ${({ layout }) => (layout === "mobile" ? tw`block lg:hidden` : tw`hidden lg:block`)}}
`
export const Text = styled(Body)`
  ${tw`text-8 lg:text-12`}
`